import { render, staticRenderFns } from "./DimensionsView.vue?vue&type=template&id=1278856d&scoped=true&"
import script from "./DimensionsView.vue?vue&type=script&lang=ts&"
export * from "./DimensionsView.vue?vue&type=script&lang=ts&"
import style0 from "./DimensionsView.vue?vue&type=style&index=0&id=1278856d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278856d",
  null
  
)

/* custom blocks */
import block0 from "./DimensionsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports